import { Component } from 'react';

class PromiseForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { submitting: false };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(...args) {
    this.submitting();
    return this.props.onSubmit(...args).then(
      response => {
        this.notSubmitting();
        return response;
      },
      error => {
        this.notSubmitting();
        throw error;
      }
    );
  }

  submitting() {
    this.setState({ submitting: true });
  }

  notSubmitting() {
    this.setState({ submitting: false });
  }

  render() {
    // Uses function as child approach
    const { children, ...rest } = this.props;
    return children({ ...rest, onSubmit: this.onSubmit, submitting: this.state.submitting });
  }
}

export default PromiseForm;
